import Box from "@mui/material/Box";
import leeftLogotype from "../assets/img/leeft-logotype.svg";

/**
 * The Leeft logotype (mark plus wordmark), self-hosted from
 * https://cdn.prod.website-files.com/682f202ade42e9e0f092fe8a/682f202ade42e9e0f092febe_Leeft_Logotype_Green.svg
 * (its fills are already #0A4145, the same teal as colorTokens.brand, so
 * no recolouring is needed). Served as a plain file, not inlined
 * (vite.config.ts's assetsInlineLimit: 0), matching leeft-mark.png.
 * Used in the signed-in app shell's top bar, next to
 * "Managed file transfer by"; the login page keeps the separate LogoMark.
 */
export function LogoType({ height = 22 }: { height?: number }) {
  return (
    <Box
      component="img"
      src={leeftLogotype}
      alt="Leeft"
      sx={{ height, width: "auto", display: "block" }}
    />
  );
}
